interface BrandingData {
  logo: string
  title: string
}

/**
 * Updates the page favicon and title with branding data
 * @param branding - The branding object containing logo and title
 */
export function updatePageBranding(branding: BrandingData) {
  // Update page title
  document.title = branding.title || 'QR Mark Verification'
  
  // Update favicon
  updateFavicon(branding.logo)
}

/**
 * Updates the favicon with a new icon URL
 * @param iconUrl - The URL of the new favicon
 */
export function updateFavicon(iconUrl: string) {
  if (!iconUrl) return
  
  // Find existing favicon link
  let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement
  
  // If no favicon exists, create one
  if (!favicon) {
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    document.head.appendChild(favicon)
  }
  
  // Update the favicon href
  favicon.href = iconUrl
}

/**
 * Resets the page branding to default values
 */
export function resetPageBranding() {
  // Reset title to default
  document.title = 'QR Mark Verification'
  
  // Reset favicon to default
  updateFavicon('/favicon.ico')
} 